/**
 * HeaderV2 – Right-side actions (notification, announcement) for V2 layout.
 * V2 layout handles back navigation via v2-header-back; this component shows icons only.
 * Uses same DOM structure as V1 (.icon-container + span) so AuthLayoutV2.style applies.
 */
import React from "react";
import iconNotification from "../../../assets/images/icon-Notification.png";
import iconAnnouncement from "../../../assets/images/icon-Megaphone.png";

export default function HeaderV2() {
  return (
    <header>
      <div className="icon-container">
        <span>
          <img src={iconNotification} width="18" height="18" alt="notification" />
        </span>
        <span>
          <img src={iconAnnouncement} width="18" height="18" alt="announcement" />
        </span>
      </div>
    </header>
  );
}
